// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPage_page__Vsup0","updated":"PrivacyPage_updated__ACm3B"};